import { render, staticRenderFns } from "./setupCompletion.vue?vue&type=template&id=6845d116"
import script from "./setupCompletion.vue?vue&type=script&lang=js"
export * from "./setupCompletion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports